import PublicQuery from 'library/util/public-query';
import { jsonToInputParams } from 'library/util/graph';

const RoiSearchPrograms = async (q = '', limit = 25, degree_type) =>
  await PublicQuery(`
    {
      search_programs(${jsonToInputParams({
        query_string: q,
        limit,
        required_pay_scale_details: true,
        degree_type,
      })}) {
        pagination {
          total
        }
        results {
          id
          degree {
            name
            level
          }
          cip {
            title
          }
          provider {
            name
          }
        }
      }
    }
  `);

export default RoiSearchPrograms;
